import { createAction } from "redux-actions";

import { moduleSlug } from "../constants";

export const getFiltersOptions = createAction(`${moduleSlug}/getFiltersOptions`);
export const getFiltersOptionsSuccess = createAction(`${moduleSlug}/getFiltersOptions/Success`);
export const getFiltersOptionsError = createAction(`${moduleSlug}/getFiltersOptions/Error`);

export const cleanupFilterData = createAction(`${moduleSlug}/cleanupFilterData`);